/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable func-names */
/* eslint-disable max-len */
import { React, useState } from 'react';
import PropTypes from 'prop-types';

const StampStaircase = function ({ imageCorpus }) {
  return (
    <div>
      <h1>Booklet Identifier</h1>
      <p>
        Welcome to the stamp booklet identifier.
        It will enable you to determine what you need to have a collectable stamp
        set given a single stamp
      </p>
      <IdentifyStamp imageCorpus={imageCorpus} />
    </div>
  );
};
StampStaircase.propTypes = {
  imageCorpus: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    filetype: PropTypes.string.isRequired,
    imagePath: PropTypes.string.isRequired,
    'collectable name': PropTypes.string,
    configurations: PropTypes.arrayOf(PropTypes.object),
  })).isRequired,
};

const IdentifyStamp = function ({ imageCorpus }) {
  const stampNames = imageCorpus.map((obj) => obj.name);
  const options = stampNames.map((sn, idx) => <option key={sn.id} value={idx}>{sn}</option>);
  const [activeStampIndex, setActiveStampIndex] = useState(0);

  return (
    <div>
      <h2>Select stamp</h2>
      <p>Select the stamp you have from the drop down list</p>
      <div className="selector-image-combo">
        <select onChange={(e) => { setActiveStampIndex(e.target.value); }}>
          {options}
        </select>
        <img className="smaller-image" src={`${process.env.PUBLIC_URL}/images${imageCorpus[activeStampIndex].imagePath}`} alt={imageCorpus[activeStampIndex].name} />
      </div>

      <Configurations configs={imageCorpus[activeStampIndex].configurations} />
    </div>
  );
};
// todo: this is a smell, if they share the same proptypes that is an indication that things need to be reorganized, but I'm passing the image corpus through so I can have dependency injection
IdentifyStamp.propTypes = StampStaircase.propTypes;

const Configurations = function ({ configs }) {
  if (!configs || configs.length === 0) {
    return (<div />);
  }
  const coverType = configs.map((obj) => Object.keys(obj).filter((k) => !['filetype', 'imagePath', 'collectable name', 'configurations'].includes(k)))[0];
  const coverNames = configs.map((obj) => obj[coverType]);
  const options = coverNames.map((sn, idx) => <option key={sn.id} value={idx}>{sn}</option>);

  const [activeCoverIndex, setActiveCoverIndex] = useState(0);
  let collectableNameE = null;
  if (configs[activeCoverIndex]['collectable name']) {
    collectableNameE = (
      <div>
        <h2>Collection Name</h2>
        <p>This collection is named:
          <b>
            {configs[activeCoverIndex]['collectable name']}
          </b>
        </p>
      </div>
    );
  }
  return (
    <div>
      <h2>
        Select {coverType}
      </h2>
      <p>The covers listed here are necessary to have a collectable set of this kind of stamp</p>

      <div className="selector-image-combo">
        <select onChange={(e) => { setActiveCoverIndex(e.target.value); }}>
          {options}
        </select>
        <img className="smaller-image" src={`${process.env.PUBLIC_URL}/images${configs[activeCoverIndex].imagePath}`} alt={configs[activeCoverIndex][coverType]} />
      </div>
      {collectableNameE}
      <Configurations configs={configs[activeCoverIndex].configurations} />
    </div>
  );
};
Configurations.propTypes = {
  configs: PropTypes.arrayOf(PropTypes.shape({
    filetype: PropTypes.string.isRequired,
    imagePath: PropTypes.string.isRequired,
    'collectable name': PropTypes.string,
    configurations: PropTypes.arrayOf(PropTypes.object),
  })).isRequired,
};

export default StampStaircase;
